/** Resource types accepted by GET/PATCH /api/admin/marketplace/:type. */
export const MARKETPLACE_TYPES = [
  { key: "project-topics", label: "Project Topics", resourceType: "PROJECT_TOPIC" },
  { key: "seminar-topics", label: "Seminar Topics", resourceType: "SEMINAR_TOPIC" },
  { key: "research-materials", label: "Research Materials", resourceType: "RESEARCH_MATERIAL" },
  { key: "manuals", label: "Manuals", resourceType: "MANUAL" },
];

export const RESOURCE_STATUS_OPTIONS = [
  { value: "", label: "All statuses" },
  { value: "PENDING", label: "Pending" },
  { value: "APPROVED", label: "Approved" },
  { value: "REJECTED", label: "Rejected" },
  { value: "DRAFT", label: "Draft" },
  { value: "DISABLED", label: "Disabled" },
  { value: "WITHDRAWN", label: "Withdrawn" },
];

export const PURCHASE_STATUS_OPTIONS = [
  { value: "", label: "All statuses" },
  { value: "COMPLETED", label: "Completed" },
  { value: "PENDING", label: "Pending" },
  { value: "PROCESSING", label: "Processing" },
  { value: "FAILED", label: "Failed" },
  { value: "CANCELLED", label: "Cancelled" },
  { value: "REFUNDED", label: "Refunded" },
  { value: "PARTIALLY_REFUNDED", label: "Partially refunded" },
];

export function formatCurrency(value, currency = "NGN") {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return "—";
  try {
    return new Intl.NumberFormat("en-NG", {
      style: "currency",
      currency,
      maximumFractionDigits: 2,
    }).format(amount);
  } catch {
    return `₦${amount.toLocaleString("en-NG", { maximumFractionDigits: 2 })}`;
  }
}

export function formatDate(value) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleString("en-NG", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function statusBadgeClass(status) {
  switch (String(status || "").toUpperCase()) {
    case "APPROVED":
    case "COMPLETED":
    case "SENT":
      return "bg-emerald-100 text-emerald-700";
    case "PENDING":
    case "PROCESSING":
    case "QUEUED":
    case "DRAFT":
      return "bg-amber-100 text-amber-700";
    case "REJECTED":
    case "FAILED":
    case "DISABLED":
      return "bg-red-100 text-red-700";
    case "WITHDRAWN":
    case "CANCELLED":
    case "REFUNDED":
    case "PARTIALLY_REFUNDED":
      return "bg-slate-200 text-slate-700";
    default:
      return "bg-slate-100 text-slate-600";
  }
}

export function purchaseItemsLabel(purchase) {
  const items = Array.isArray(purchase?.items) ? purchase.items : [];
  const titles = items.map((item) => item.title).filter(Boolean);
  if (titles.length) return titles.join(", ");
  return purchase?.itemId || "—";
}
